// extracted by css-extract-rspack-plugin
export default {"item":"item-qvWqHN","headerItem":"headerItem-rmRUIs"};